import Client from '../axiosClient'
const resource = '/join_us';
const resourceInit = 'join_us_initialize';
const resourceUpdateStatus = 'join_us_status_update';
const verifyEmail = 'verify_email';
const emailNotificationSend = 'email_notification_send';
const showkPhoneEmail = 'show_phone_email';
export default {
    init() {
      return Client.get(`${resourceInit}`);
    },
    get(payload) {
      let filterParam='';
      if(payload) {
        console.log('Join Us Repository:',payload);
        let filterParam = 'requestFrom='+payload['requestFrom'];
        this.filterParam=filterParam+`&page=${payload['pageNo']}&pageLength=${payload['pageLength']}`;
        return Client.get(`${resourceInit}?${this.filterParam}`);
      //  return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
      }
      return Client.get(`${resource}`);
  
    },
  
    getById(id) {
      return Client.get(`${resource}/${id}`);
    },
  
    post(payload) {
      return Client.post(`${resource}`, payload);
    },
    
    updateStatus(payload) {
      return Client.post(`${resourceUpdateStatus}`, payload);
    },

    verifyEmailMethod(payload) {
      return Client.post(`${verifyEmail}`, payload);
    },
    notificationSend(payload){
      return Client.post(`${emailNotificationSend}`, payload);
    },
    showkPhoneEmail(payload){
      return Client.post(`${showkPhoneEmail}`, payload);
    },
  };


// WEBPACK FOOTER //
// ./src/repositories/business/joinUsRepository.js